import { useCallback, useEffect } from 'react';
import Helmet from 'react-helmet';
import { useParams } from 'react-router-dom';

import { DefaultSheet } from 'twyne-new.ui';

import { useActiveForm } from '@/components/form/ActiveSwitch';
import FormWrapper from '@/components/form/Wrapper';
import { useAppAlert } from '@Components/AppAlert';
import PrivateRoute, { Router } from '@Components/app-layout/PrivateRoute';
import history from 'utils/history';

import Form from '../components/Form';
import Heading from '../components/Heading';
import { RewardProvider, useRewardStore } from '../store';
import StepLayout from '../views/step/Layout';

function RewardForm() {
  const { id } = useParams()
  const { collection: { item, useLoad, useSubmit, reset }, reloadReward } = useRewardStore()
  const { handleSuccess, handleError } = useAppAlert()
  const { active, setActive } = useActiveForm(item)

  const loadData = useLoad(id)
  const { pathname } = history.location

  useEffect(() => {
    loadData()
  }, [loadData, pathname])

  const handleSubmit = useSubmit()

  const handleClose = useCallback(() => {
    history.push("/cms/rewards")
    reset()
  }, [reset])

  const handleSubmitAndRedirect = useCallback(async payload => {
    try {
      const result = await handleSubmit({ ...payload, active })
      if (result?.id) {
        await reloadReward(result.id)
      }
      const message = payload.id ? 'edited' : 'created'
      handleSuccess('Success', `Reward ${message}.`)
      history.push(`/cms/rewards/${result.id}`)
    } catch {
      handleError('Error', 'Reward was not saved.')
    }
  }, [handleSubmit, handleSuccess, handleError, active, reloadReward])

  if (!item) {
    return null
  }

  if (item.id) {
    return <FormWrapper title='Reward'>
      <Heading item={item} active={active} onChangeActive={setActive} />
      <Form data={item} handleSubmit={handleSubmitAndRedirect} handleRefresh={loadData} />
    </FormWrapper>
  }

  return <DefaultSheet
    wrapperProps={{ defaultOpen: true, onOpenChange: open => !open && handleClose() }}
    title='Add Reward'>
    <Helmet title='Reward' />
    <Form data={item} handleSubmit={handleSubmitAndRedirect} handleRefresh={loadData} isAdd />
  </DefaultSheet>
}

export default function RewardFormLayout() {
  return <RewardProvider>
    <Router>
      <PrivateRoute exact path={"/cms/rewards/add"} component={RewardForm} />
      <PrivateRoute path={"/cms/rewards/:id"} component={RewardForm} />
    </Router>
    <StepLayout />
  </RewardProvider>
}
